/**
 * Utility function to extract and format validation errors from API responses
 * Handles multiple error response formats from the API
 */
export const extractValidationErrors = (error: any, defaultMsg: string = "Operation failed"): string => {
  let errorMsg = defaultMsg;

  try {
    if (error && error.response && error.response.data) {
      const responseData = error.response.data;

      // Check for result.errors (primary structure from API)
      if (responseData.result && responseData.result.errors && Array.isArray(responseData.result.errors)) {
        const errorList = responseData.result.errors.filter((e: any) => e && typeof e === 'string');
        if (errorList.length > 0) {
          errorMsg = errorList.join(", ");
          return errorMsg;
        }
      }

      // Check for data.errors (secondary structure)
      if (responseData.data && responseData.data.errors && Array.isArray(responseData.data.errors)) {
        const errorList = responseData.data.errors.filter((e: any) => e && typeof e === 'string');
        if (errorList.length > 0) {
          errorMsg = errorList.join(", ");
          return errorMsg;
        }
      }

      // Check for root level errors array
      if (responseData.errors && Array.isArray(responseData.errors)) {
        const errorList = responseData.errors.filter((e: any) => e && typeof e === 'string');
        if (errorList.length > 0) {
          errorMsg = errorList.join(", ");
          return errorMsg;
        }
      }

      // Check if it's a ModelState error object (ASP.NET validation)
      if (responseData.errors && typeof responseData.errors === 'object' && !Array.isArray(responseData.errors)) {
        const errorMessages: string[] = [];
        Object.keys(responseData.errors).forEach((key) => {
          const fieldErrors = responseData.errors[key];
          if (Array.isArray(fieldErrors)) {
            fieldErrors.forEach((msg: string) => {
              if (msg) errorMessages.push(msg);
            });
          } else if (typeof fieldErrors === 'string') {
            errorMessages.push(fieldErrors);
          }
        });
        if (errorMessages.length > 0) {
          errorMsg = errorMessages.join(", ");
          return errorMsg;
        }
      }

      // Fallback: use message field
      if (typeof responseData.message === 'string' && responseData.message) {
        return responseData.message;
      }
    } else if (error && error.message) {
      return error.message;
    }
  } catch (e) {
    console.error("Error while parsing validation errors:", e);
  }

  return errorMsg;
};
